/* unplugin-vue-components disabled */import { ElForm as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElButton as __unplugin_components_4 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElFormItem as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import __unplugin_components_0 from '/Users/liao/work/cmge/ultrasdk/ultrasdk.hub.web/packages/base/src/components/GameChannelSelect/index.vue';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "flex justify-between"
};
import { UseSwitchCommon } from './hooks';
import UTable from '@ultra/share/components/UTable/index.vue';
import { UseTable } from '@ultra/share/components/UTable/useTable';
import { apiUsdkSwitchConfGetVersion, apiUsdkSwitchConfDelVersion } from '@/api/usdk';
import AddEditVersion from './modules/addEditVersion.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'forceUpdate',
  setup(__props) {
    const gid = computed(() => UseSwitchCommon().gid);
    const filter = ref({
      cid: undefined,
      updateForce: undefined
    });
    const addEditVersionRef = ref();
    const columns = [{
      label: '渠道ID',
      prop: 'cid'
    }, {
      label: '渠道名称',
      prop: 'cname'
    }, {
      label: '更新时间',
      prop: 'updateTime'
    }, {
      label: 'VersionName',
      prop: 'verName'
    }, {
      label: 'VersionCode',
      prop: 'verCode'
    }, {
      label: '包体大小',
      prop: 'verSize'
    }, {
      label: '更新链接',
      prop: 'updateUrl'
    }, {
      label: '更新类型',
      prop: 'updateForce',
      slot: 'updateForce'
    }, {
      label: '操作',
      action: true
    }];
    const handleClick = (type, data) => {
      if (type === 'edit' || type === 'add') {
        addEditVersionRef.value.show({
          type,
          data,
          gid: gid.value
        });
      } else {
        ElMessageBox.confirm('是否确认删除？', '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiUsdkSwitchConfDelVersion({
            id: data.id,
            cid: data.cid,
            gid: gid.value
          }).then(res => {
            if (res.code === 0) {
              getTableData();
            }
          });
        }).catch(() => {
          console.log('取消');
        });
      }
    };
    const getTableData = () => {
      tableLoading.value = true;
      apiUsdkSwitchConfGetVersion({
        gid: gid.value,
        ...filter.value
      }).then(res => {
        console.log(res);
        if (res.code === 0) {
          tableData.value = res.data;
        }
        tableLoading.value = false;
      });
    };
    const {
      tableData,
      tableLoading
    } = UseTable(getTableData);
    watch(() => gid.value, val => {
      if (val) {
        getTableData();
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_game_channel_select = __unplugin_components_0;
      const _component_el_form_item = __unplugin_components_1;
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_el_button = __unplugin_components_4;
      const _component_el_form = __unplugin_components_5;
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createVNode(_component_el_form, {
        inline: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "选择渠道"
        }, {
          default: _withCtx(() => [_createVNode(_component_game_channel_select, {
            modelValue: _unref(filter).cid,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(filter).cid = $event),
            clearable: "",
            gid: _unref(gid),
            onChange: getTableData
          }, null, 8, ["modelValue", "gid"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "强更类型"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(filter).updateForce,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(filter).updateForce = $event),
            placeholder: "请选择强更类型"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_option, {
              label: "全部",
              value: ""
            }), _createVNode(_component_el_option, {
              label: "强更",
              value: 1
            }), _createVNode(_component_el_option, {
              label: "非强更",
              value: 0
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            onClick: getTableData,
            type: "primary"
          }, {
            default: _withCtx(() => [_createTextVNode("搜索")]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[2] || (_cache[2] = $event => handleClick('add'))
      }, {
        default: _withCtx(() => [_createTextVNode("添加版本")]),
        _: 1
      })]), _createVNode(UTable, {
        options: columns,
        data: _unref(tableData),
        loading: _unref(tableLoading)
      }, {
        updateForce: _withCtx(({
          scope
        }) => [_createTextVNode(_toDisplayString(scope.row.updateForce ? '强更' : '非强更'), 1)]),
        action: _withCtx(({
          scope
        }) => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          onClick: $event => handleClick('edit', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("修改")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "danger",
          onClick: $event => handleClick('del', scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode("删除")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 8, ["data", "loading"]), _createVNode(AddEditVersion, {
        ref_key: "addEditVersionRef",
        ref: addEditVersionRef,
        onSuccess: getTableData
      }, null, 512)], 64);
    };
  }
});